/* Velaine: de grote productfoto wisselt mee met de kleur die je kiest in de Kaching-bundel.
   Werkt via dezelfde route als de kleurkiezer van het thema: de productsectie opnieuw ophalen
   voor de gekozen variant en de fotogalerij vervangen. */
(function () {
  if (window.__velaineKachingPhotos) return;
  window.__velaineKachingPhotos = true;

  var productPromise = null;
  var currentColor = null;
  var controller = null;

  function getProduct() {
    if (!productPromise) {
      var path = window.location.pathname.replace(/\/$/, '');
      productPromise = fetch(path + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productPromise;
  }

  function isColorSelect(el) {
    if (!(el instanceof HTMLSelectElement)) return false;
    if (!el.closest('kaching-bundle, kaching-bundles-block, .kaching-bundles')) return false;
    var name = (el.getAttribute('data-name') || el.getAttribute('data-option-name') || el.getAttribute('aria-label') || '').toLowerCase();
    return name.indexOf('kleur') !== -1 || name.indexOf('color') !== -1 || name.indexOf('colour') !== -1;
  }

  function colorIndex(product) {
    var names = (product.options || []).map(function (o) {
      return String(typeof o === 'string' ? o : o.name).toLowerCase();
    });
    for (var i = 0; i < names.length; i++) {
      if (names[i].indexOf('kleur') !== -1 || names[i].indexOf('color') !== -1) return i;
    }
    return 0;
  }

  function findVariant(product, color) {
    var idx = colorIndex(product);
    var key = 'option' + (idx + 1);
    var matches = product.variants.filter(function (v) { return v[key] === color; });
    return matches.filter(function (v) { return v.available; })[0] || matches[0] || null;
  }

  function showColor(color) {
    if (!color || color === currentColor) return;
    var gallery = document.querySelector('media-gallery');
    var section = gallery && gallery.closest('.shopify-section');
    if (!gallery || !section || !section.id) return;
    var sectionId = section.id.replace(/^shopify-section-/, '');

    getProduct().then(function (product) {
      if (!product) return;
      var variant = findVariant(product, color);
      if (!variant) return;
      currentColor = color;
      if (controller) controller.abort();
      controller = new AbortController();
      var url = window.location.pathname + '?variant=' + variant.id + '&section_id=' + encodeURIComponent(sectionId);
      return fetch(url, { signal: controller.signal, credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('media-gallery');
          var old = document.querySelector('media-gallery');
          if (fresh && old) old.replaceWith(fresh);
        });
    }).catch(function (e) {
      if (!e || e.name !== 'AbortError') currentColor = null;
    });
  }

  document.addEventListener('change', function (event) {
    var el = event.target;
    if (isColorSelect(el) && el.value) showColor(el.value);
  }, true);
})();
